import store from "../../appRedux/store";
import { identityApi as api, identityApiV2 } from "../Api";

class BusinessGroupServices {
  getMyBusinessGroup() {
    return api
      .get(`business/BusinessGroup`, {
        headers: { ...store.getState().auth.headers, "x-app-language-id": 1 },
      })
      .then((response) => {
        return response;
      });
  }

  getMyBusinessGroups() {
    return identityApiV2
      .get(`business/BusinessGroup`, {
        headers: { ...store.getState().auth.headers, "x-app-language-id": 1 },
      })
      .then((response) => {
        return response;
      });
  }

  getMyBusinessGroupById(id) {
    return api
      .get(
        `business/BusinessGroup/my-business-group-multilingual?BusinessGroupId=${id}`,
        {
          headers: { ...store.getState().auth.headers, "x-app-language-id": 1 },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("Error", error);
      });
  }

  updateMyBusinessGroup(body) {
    return api
      .put(`business/BusinessGroup/my-business-group-multilingual`, body, {
        headers: { ...store.getState().auth.headers, "x-app-language-id": 1 },
      })
      .then((response) => {
        return response.data.data;
      });
  }
}

export default new BusinessGroupServices();
